import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import listingService from '../services/listingService';
import LoadingSpinner from '../components/common/LoadingSpinner';
import Alert from '../components/common/Alert';
import { formatDate } from '../utils/formatters';
import './ApplicantPages.css';

const messageFrom = (err, fallback) => err.response?.data?.message || err.message || fallback;

const ListingsPage = () => {
  const [listings, setListings] = useState(null);
  const [error, setError] = useState('');
  const [applyingToken, setApplyingToken] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    listingService
      .getListings()
      .then(setListings)
      .catch((err) => setError(messageFrom(err, 'Listings could not be loaded.')));
  }, []);

  const apply = async (token) => {
    setApplyingToken(token);
    setError('');
    try {
      const { application_id: applicationId } = await listingService.apply(token);
      navigate(`/applicant/application/${applicationId}`);
    } catch (err) {
      setError(messageFrom(err, 'This application could not be started.'));
      setApplyingToken(null);
    }
  };

  if (!listings && !error) return <LoadingSpinner fullPage />;

  return (
    <div className="ap-page">
      <h1>Available properties</h1>
      <p className="ap-muted">Properties landlords and agents have made available to apply for directly.</p>

      {error && <Alert type="error" message={error} dismissible onClose={() => setError('')} />}

      {listings && listings.length === 0 ? (
        <div className="ap-card">
          <p>There are no properties available to apply for right now. Check back later.</p>
        </div>
      ) : (
        <ul className="ap-list">
          {listings?.map((listing) => (
            <li key={listing.token} className="ap-card ap-list__item">
              <div>
                <h2 className="ap-list__title">{listing.address}</h2>
                <p className="ap-muted">{listing.organisation_name}</p>
                <p className="ap-muted">
                  {listing.monthly_rent} / month · {listing.property_type}
                  {listing.occupation_date && ` · Available from ${formatDate(listing.occupation_date)}`}
                </p>
                {!listing.authority_verified && (
                  <p className="ap-muted">Note: this landlord's authority to let this property has not been verified yet.</p>
                )}
              </div>
              <div className="ap-list__actions">
                <button
                  type="button"
                  className="btn-primary ap-button"
                  disabled={applyingToken === listing.token}
                  onClick={() => apply(listing.token)}
                >
                  {applyingToken === listing.token ? 'Starting…' : 'Apply'}
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ListingsPage;
